module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/bar-tab-icon-2a47418d7d5ecda1fa982661c03750fb.png";